export default "__VITE_ASSET__D5U7nCWK__"